import React, { useMemo, useState } from 'react';

const defaultLocalVideos = [
  {
    id: 'video-01',
    title: '01 AI - Tag Conversion | 02 AI - Quick Script Conversion | 03 AI - SQL Optimization - Live Demo',
    description: 'Tag Conversion & Validation Agent',
    subDescription: 'Automatically maps and converts Wonderware (In Touch and System Platform) tags to Ignition Tags and UDTs, generating ready-to-import JSON files with validation capabilities.',
    src: '/videos/01 AI - Tag Conversion - Live Demo.mp4'
  },
  {
    id: 'video-04',
    title: '04 AI - Tags creation from UDT',
    description: 'AI Enabled Tag Creation / UDT',
    subDescription: 'Creates new tags and UDTs from prompts through natural language.',
    src: '/videos/04 AI - Tags creation from UDT.mp4'
  },
  {
    id: 'video-05',
    title: '05 AI - UI Screen Migration Wonderware to Ignition',
    description: 'AI Enabled Screen Migration',
    subDescription: 'Screen Migration AI converts Wonderware InTouch files to Ignition Perspective JSON, creating new views from prompts through natural language.',
    src: '/videos/05 AI - UI Screen Migration Wonderware to Ignition.mp4'
  },
  {
    id: 'video-06',
    title: '06 AI - UI Component addition',
    description: 'AI Enabled New Screen/View creation from template (for Ignition Perspective UI)',
    subDescription: 'Creating new perspective screens and views from prompts through natural language (based on template).',
    src: '/videos/06 AI - UI Component addition.mp4'
  },
  {
    id: 'video-07',
    title: '07 AI - HMI ISA101 Conversion',
    description: 'AI Based "ISA-101" HMI design rules enforcement (for Ignition Perspective UI)',
    subDescription: 'Automatically updates the Perspective UI layout for ISA-101 from prompts through natural language.',
    src: '/videos/07 AI - HMI ISA101 Conversion.mp4'
  },
  {
    id: 'video-08',
    title: '08 Test Automation Framework for Ignition UI + AI',
    description: 'Test Automation Framework',
    subDescription: 'Test automation for Ignition Perspective UIs using Python, Pytest, Selenium, and Ignition Tools Library, executing test scripts from AI prompts through natural language.',
    src: '/videos/08 Test Automation Framework for Ignition UI + AI.mp4'
  },
  {
    id: 'video-09',
    title: '09 AI - Status IQ',
    description: 'AI Based Comms summary or Alarms summary comparison for IGNITION/ACM',
    subDescription: 'AI-based automatic detection of meter communication failures, new outages, recovering devices, and escalating issues across thousands of devices; plus AI-based N8N workflow automation to connect multiple ACM databases with Flow-Cal for data validation.',
    src: '/videos/09 AI - Status IQ.MP4'
  },
  {
    id: 'video-10',
    title: '10 AI - WEGA',
    description: 'Wipro WEGA AI Agent for Automated User Story generation / Pipeline Creation',
    subDescription: 'Users can create user stories from documents and prompts. AI-generated stories can be reviewed and updated by users, and after approval are created automatically in Azure DevOps.',
    src: '/videos/10 AI - WEGA.mp4'
  }
];

function VideosLibrary() {
  const [videos] = useState(defaultLocalVideos);
  const [activeVideoId, setActiveVideoId] = useState(defaultLocalVideos[0]?.id || null);

  const activeVideo = useMemo(
    () => videos.find((video) => video.id === activeVideoId) || videos[0],
    [activeVideoId, videos]
  );

  return (
    <div className="videos-page">
      <div className="page-header">
        <h1 className="page-title">Video Library</h1>
      </div>

      <div className="videos-layout">
        <section className="video-list card" aria-label="Video list">
          <h2 className="videos-section-title">Available Videos</h2>
          <ul className="videos-list-reset">
            {videos.map((video) => {
              const isActive = activeVideo.id === video.id;
              return (
                <li key={video.id}>
                  <button
                    type="button"
                    className={`video-list-item ${isActive ? 'active' : ''}`}
                    onClick={() => setActiveVideoId(video.id)}
                  >
                    <div className="video-list-item-header">
                      <strong>{video.title}</strong>
                    </div>
                    <p>{video.description}</p>
                    <p>{video.subDescription}</p>
                    <div className="video-list-meta">
                      <span className="video-list-play">Play</span>
                    </div>
                  </button>
                </li>
              );
            })}
          </ul>
        </section>

        <section className="video-player card" aria-label="Video player">
          <h2 className="videos-section-title">Now Playing</h2>
          <div className="video-player-shell">
            <video
              key={activeVideo.id}
              className="video-element"
              controls
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture
              preload="metadata"
              poster={activeVideo.poster}
            >
              <source src={activeVideo.src} type="video/mp4" />
              Your browser does not support HTML video playback.
            </video>
          </div>
          <div className="video-details">
            <h3>{activeVideo.title}</h3>
            <p>{activeVideo.description}</p>
            <p>{activeVideo.subDescription}</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default VideosLibrary;
